import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import toast from "react-hot-toast";
import { setVaccinationOverdueData } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export interface ILabSampleRequest {
  requisition_id: string;
  lab_partner_id: string;
  test_barcode: string;
}

export interface IVaccinationOCRResponseData {
  overdue_response?: {
    unique_dose_key: string;
    is_overdue: boolean;
  }[];
}

export interface IVaccinationOCRResponse {
  status: boolean;
  message: string;
  data: IVaccinationOCRResponseData;
}

export const useVaccinationOCRDataSubmissionAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletDetailsInProgress
  const execute = useCallback(
    async (paramsBody: any, userId: string, pet_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .put(`${CUSTOMER_APIS?.VACCINATION_DATA_RECORD?.baseURL}`, paramsBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IVaccinationOCRResponse>) => {
            if (res.data.status === true) {
              toast.success(res.data.message);
              dispatch(setVaccinationOverdueData({ data: res?.data?.data }));
              return {
                status: true,
                message: res.data.message,
              };
            } else {
              dispatch(setVaccinationOverdueData({ data: {} }));
              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
